// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*******************************
STYLES BUTTONS
*******************************/
.loader-container {
  opacity: 0.8;
  background: rgba(255, 255, 255, 0.6);
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: 1000;
}

.loading-global-container {
  float: left;
  width: 100%;
  display: flex !important;
  padding-top: 15pt;
  padding-bottom: 15pt;
}

.loader-spinner {
  border: 10px solid #f3f3f3;
  border-top: 10px solid #37A14B;
  border-radius: 50%;
  margin: auto;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% { /* Chrome, Opera 15+, Safari 3.1+ */ /* IE 9 */
    transform: rotate(0deg); /* Firefox 16+, IE 10+, Opera */
  }
  100% { /* Chrome, Opera 15+, Safari 3.1+ */ /* IE 9 */
    transform: rotate(360deg); /* Firefox 16+, IE 10+, Opera */
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
